import { render, staticRenderFns } from "./profissional-new-ux.vue?vue&type=template&id=704c9c5a&"
import script from "./profissional-new-ux.vue?vue&type=script&lang=js&"
export * from "./profissional-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704c9c5a')) {
      api.createRecord('704c9c5a', component.options)
    } else {
      api.reload('704c9c5a', component.options)
    }
    module.hot.accept("./profissional-new-ux.vue?vue&type=template&id=704c9c5a&", function () {
      api.rerender('704c9c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profissional-new-ux.vue"
export default component.exports